import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import SubsidyModal from "./modal/SubsidyModal";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSubsidySource,
  fetchSubsidyType,
} from "../../../../features/fetch/fetchSlice";
import svg47 from "../../../../assets/svg/svg47.svg";
import svg62 from "../../../../assets/svg/svg62.svg";
import { cashConverter } from "../../../../utils";

function CardExpression() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeObjexpIsp } = useSelector((state) => ({
    activeObjexpIsp: state.obj.activeObj["expressionIsp"],
  }));
  const { activeObjexpressions } = useSelector((state) => ({
    activeObjexpressions: state.obj.activeObj["expressions"],
  }));
  const { open, handleCancel, handleOpen } = useModalToggle();
  const handleFetch = () => {};

  useEffect(() => {
    dispatch(fetchSubsidyType());
    dispatch(fetchSubsidySource());
  }, []);
  const items = [
    {
      title: "Estimated Cost",
      total: activeObjexpIsp?.estimatedCost || 0,
    },
    {
      title: "Subsidy",
      total: activeObjexpIsp?.projectSubsidy || 0,
      btnTitle: "Add",
    },
    { title: "Farmers Pay", total: activeObjexpIsp?.projectFarmersCost || 0 },
  ];
  
  const itemsPublished = [
    { title: "Initial Cost", total: activeObjexpIsp?.estimatedCost || 0 },
    { title: "Standardised Cost", total: activeObjexpIsp?.projectBoqTotalStandardized || 0 },
    {
      title: "Subsidy",
      total: activeObjexpIsp?.projectSubsidy || 0,
    },
    {
      title: "Farmers Pay",
      total: activeObjexpIsp?.projectFarmersCost || 0,
      link: "/farmer-paylist",
      svgSide: true,
    },
  ];
 
  return (
    <div className="mt-[1.75rem]">
      {activeObjexpIsp?.projectBidStatus?.trim()?.toUpperCase() === "ACCEPTED"  || activeObjexpIsp?.projectBidStatus?.trim()?.toUpperCase() === "REJECTED" ? (
        <div className=" flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
          {itemsPublished &&
            itemsPublished?.map((item) => (
              <div
                onClick={() => navigate(activeObjexpIsp?.projectBidStatus?.trim()?.toUpperCase() === "REJECTED" ? null :item?.link)}
                key={`${item?.title}-${item?.total}`}
                style={{
                  borderRadius: "0.75rem",
                  background: "#FFF",
                  boxShadow: "0px 4px 20px 0px rgba(7, 6, 18, 0.10)",
                }}
                className="p-[1.25rem] border border-[#D6E1F5] lg:w-[280px] w-full cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div className="dash-card-h1 ">{item?.title}</div>
                  {item?.svgSide && (
                    <div>
                      <img src={svg62} alt="svg62" />
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-between w-full mt-[.5rem]">
                  <div className="dash-card-h1 !text-[1.5rem] !font-[500] !text-[#0092CC] flex items-center !h-[2.8125rem]">
                    {cashConverter(item?.total)}
                  </div>

                  {item?.btnTitle && (
                    <button
                      onClick={() => handleOpen()}
                      className={`${
                        item?.total > 1
                          ? "w-[65px] flex justify-end"
                          : "cstm-btn-2 !w-[65px] flex-shrink-0 flex items-center justify-center"
                      }`}
                    >
                      {item?.total > 0 ? (
                        <img src={svg47} alt="svg47" />
                      ) : (
                        "Add"
                      )}
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>
      ) : activeObjexpIsp?.projectBidStatus?.trim()?.toUpperCase() === "SUBMITTED"? (
        <div className=" flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
          {items &&
            items?.map((item) => (
              <div
                onClick={() => navigate(item?.link)}
                key={`${item?.title}-${item?.total}`}
                style={{
                  borderRadius: "0.75rem",
                  background: "#FFF",
                  boxShadow: "0px 4px 20px 0px rgba(7, 6, 18, 0.10)",
                }}
                className="p-[1.25rem] border border-[#D6E1F5] lg:w-[280px] w-full cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div className="dash-card-h1 ">{item?.title}</div>
                  {item?.svgSide && (
                    <div>
                      <img src={svg62} alt="svg62" />
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-between w-full mt-[.5rem]">
                  <div className="dash-card-h1 !text-[1.5rem] !font-[500] !text-[#0092CC] flex items-center !h-[2.8125rem]">
                    {cashConverter(item?.total)}
                  </div>

                  {(item?.btnTitle &&activeObjexpIsp?.projectBidStatus === 'SUBMITTED_FOR_STANDARDIZATION') && (
                    <button
                      onClick={() => handleOpen()}
                      className={`${
                        item?.total > 1
                          ? "w-[65px] flex justify-end"
                          : "cstm-btn-2 !w-[65px] flex-shrink-0 flex items-center justify-center"
                      }`}
                    >
                      {item?.total > 0 ? (
                        <img src={svg47} alt="svg47" />
                      ) : (
                        "Add"
                      )}
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>
      ):(<div className=" flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
        {items &&
          items?.map((item) => (
            <div
              onClick={() => navigate(item?.link)}
              key={`${item?.title}-${item?.total}`}
              style={{
                borderRadius: "0.75rem",
                background: "#FFF",
                boxShadow: "0px 4px 20px 0px rgba(7, 6, 18, 0.10)",
              }}
              className="p-[1.25rem] border border-[#D6E1F5] lg:w-[280px] w-full cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <div className="dash-card-h1 ">{item?.title}</div>
                {item?.svgSide && (
                  <div>
                    <img src={svg62} alt="svg62" />
                  </div>
                )}
              </div>

              <div className="flex items-center justify-between w-full mt-[.5rem]">
                <div className="dash-card-h1 !text-[1.5rem] !font-[500] !text-[#0092CC] flex items-center !h-[2.8125rem]">
                  {cashConverter(item?.total)}
                </div>

                {(item?.btnTitle &&activeObjexpIsp?.projectBidStatus === 'SUBMITTED_FOR_STANDARDIZATION') && (
                  <button
                    onClick={() => handleOpen()}
                    className={`${
                      item?.total > 1
                        ? "w-[65px] flex justify-end"
                        : "cstm-btn-2 !w-[65px] flex-shrink-0 flex items-center justify-center"
                    }`}
                  >
                    {item?.total > 0 ? (
                      <img src={svg47} alt="svg47" />
                    ) : (
                      "Add"
                    )}
                  </button>
                )}
              </div>
            </div>
          ))}
      </div>)}

      <SubsidyModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={handleFetch}
      />
    </div>
  );
}

export default CardExpression;
